import { useMutation, useQuery } from "@apollo/client";
import {
  Button,
  Grid,
  LoadingOverlay,
  ScrollArea,
  Select,
  Stack,
  TextInput,
} from "@mantine/core";
import { useForm } from "@mantine/form";
import { useViewportSize } from "@mantine/hooks";
import { showNotification } from "@mantine/notifications";
import { UPDATE_SHIPPING } from "apollo/mutuations";
import { GET_MY_WARE_HOUSES } from "apollo/queries";
import { customLoader } from "components/utilities/loader";
import { useEffect, useState } from "react";

const ShippingUpdateModal = ({ setOpenedEdit, row }) => {
  const [warehouses, setWarehouses] = useState([]);
  const [subcategories, setSubcategories] = useState([]);
  const [categories, setCategories] = useState([]);
  const [tempWarhouse, setTempWarehouse] = useState([]);
  const form = useForm({
    initialValues: {
      warehouse_id: "",
      category_id: "",
      category: "",
      period_type: "",
      min_period: 0,
      max_period: 0,
    },
    validate: {
      min_period: (value) => {
        if (value === null || value === "" || value === undefined)
          return "Min period is required";
        if (isNaN(Number(value))) return "Must be a number";
        if (Number(value) < 0) return "Min period can't be negative";
        if (Number(value) === 0) return "Min period can't be zero";
        return null;
      },
      max_period: (value) => {
        if (value === null || value === "" || value === undefined)
          return "Max period is required";
        if (isNaN(Number(value))) return "Must be a number";
        if (Number(value) < 0) return "Max period can't be negative";
        if (Number(value) === 0) return "Max period can't be zero";
        return null;
      },
    },
  });
  const { loading: supplierLoading } = useQuery(GET_MY_WARE_HOUSES, {
    variables: {
      first: parseInt(1000),
      page: 1,
    },

    onCompleted(data) {
      const arr = data.myWarehouses.data.map((item) => ({
        label: item.name,
        value: item.id,
      }));

      setWarehouses(arr);
      setTempWarehouse(data.myWarehouses.data);
    },
  });

  useEffect(() => {
    if (row) {
      form.setValues({
        warehouse_id: row.warehouse.id,
        category: row.category.id,
        category_id: row.category.id,
        period_type: row.period_type,
        min_period: row.min_period,
        max_period: row.max_period,
      });
      const selectedWarehouse = tempWarhouse.find(
        (wh) => wh.id === row.warehouse.id,
      );
      const categories =
        selectedWarehouse?.supplier?.categories?.map((item) => item.category) ||
        [];
      console.log(categories);
      setCategories(categories);
    }
  }, [row]);
  useEffect(() => {
    if (row) {
      const selectedWarehouse = tempWarhouse.find(
        (wh) => wh.id === row.warehouse.id,
      );
      const categories =
        selectedWarehouse?.supplier?.categories?.map((item) => item.category) ||
        [];
      setCategories(categories);
    }
  }, [tempWarhouse]);
  const [updateShipping, { loading: warehouseManagerLoading }] =
    useMutation(UPDATE_SHIPPING);

  const { height } = useViewportSize();
  const submit = () => {
    if (form.validate().hasErrors) {
      return;
    }
    updateShipping({
      variables: {
        id: row.id,
        warehouse_id: form.getInputProps("warehouse_id").value,
        category_id: form.getInputProps("category_id").value,
        period_type: form.getInputProps("period_type").value,
        min_period: parseInt(form.getInputProps("min_period").value),
        max_period: parseInt(form.getInputProps("max_period").value),
      },
      onCompleted(data) {
        showNotification({
          color: "green",
          title: "Success",
          message: "Shipping Estimation updated Successfully",
        });
        setOpenedEdit(false);
      },
      onError(error) {
        showNotification({
          color: "red",
          title: "Error",
          message:
            error?.graphQLErrors?.[0]?.message ||
            "Shipping Estimation Not Updated Successfully",
        });
      },
    });
  };
  const handleCategoryChange = (val) => {
    form.setFieldValue("category_id", val);
  };
  const setWarehouseDropDownValue = (val) => {
    form.setFieldValue("warehouse_id", val);
    const selectedWarehouse = tempWarhouse.find((wh) => wh.id === val);
    const categories =
      selectedWarehouse?.supplier?.categories?.map((item) => item.category) ||
      [];
    console.log(categories);
    setCategories(categories);
  };

  return (
    <>
      <LoadingOverlay
        visible={warehouseManagerLoading}
        color="blue"
        overlayBlur={2}
        loader={customLoader}
      />
      <ScrollArea style={{ height: height / 1.8 }} type="auto" offsetScrollbars>
        <form onSubmit={form.onSubmit(() => submit())}>
          <Stack>
            <Grid>
              <Grid.Col span={4}>
                <Select
                  data={warehouses}
                  value={form.getInputProps("warehouse_id")?.value?.toString()}
                  onChange={setWarehouseDropDownValue}
                  label="Warehouse"
                  placeholder="Pick a warehouse"
                  searchable
                />

                <Select
                  searchable
                  data={categories.map((sub) => ({
                    label: sub.name,
                    value: sub.id,
                  }))}
                  value={form.getInputProps("category_id").value?.toString()}
                  onChange={handleCategoryChange}
                  label="Category"
                  placeholder="Pick a Category"
                  // disabled={categories.length === 0}
                />
              </Grid.Col>

              <Grid.Col span={2}>
                <Select
                  data={["DAY", "WEEK", "HOUR"]}
                  label="Period type"
                  placeholder="Period type"
                  {...form.getInputProps("period_type")}
                />
              </Grid.Col>
              <Grid.Col span={2}>
                <TextInput
                  required
                  type="number"
                  label="Min period"
                  placeholder="Min period"
                  {...form.getInputProps("min_period")}
                />
              </Grid.Col>
              <Grid.Col span={2}>
                <TextInput
                  required
                  type="number"
                  label="Max period"
                  placeholder="Max period"
                  {...form.getInputProps("max_period")}
                />
              </Grid.Col>
            </Grid>

            <Grid>
              <Grid.Col span={4}>
                <Button
                  style={{
                    width: "25%",
                    marginTop: "15px",
                    backgroundColor: "#FF6A00",
                    color: "#FFFFFF",
                  }}
                  type="submit"
                  fullWidth
                >
                  Submit
                </Button>
              </Grid.Col>
            </Grid>
          </Stack>
        </form>
      </ScrollArea>
    </>
  );
};

export default ShippingUpdateModal;
